import { FETCH_USER_ATTRIBUTES_STARTED, FETCH_USER_ATTRIBUTES_SUCCEEDED, SET_HAS_SEEN_DEAL_STAGE_FORECAST_TOUR, SET_HAS_SEEN_FMO_MIGRATION_TOUR } from './ActionTypes';
import { fetchHasSeenTourSettings, setHasSeenDealStageTourSetting, setHasSeenFmoAdminMigrationTourSetting } from '../api/usersApi';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
import { HAS_SEEN_DEAL_STAGE_TOUR_SETTING, HAS_SEEN_FMO_MIGRATION_TOUR_SETTING } from '../constants/SettingsTypes';
export function fetchDisplayOptions() {
  return dispatch => {
    dispatch({
      type: FETCH_USER_ATTRIBUTES_STARTED
    });
    fetchHasSeenTourSettings().then(settingsAttributeStrings => {
      const hasSeenDealStageForecastTour = JSON.parse(settingsAttributeStrings[HAS_SEEN_DEAL_STAGE_TOUR_SETTING]);
      const hasSeenFmoMigrationTour = JSON.parse(settingsAttributeStrings[HAS_SEEN_FMO_MIGRATION_TOUR_SETTING]);
      dispatch({
        type: FETCH_USER_ATTRIBUTES_SUCCEEDED,
        payload: {
          hasSeenDealStageForecastTour,
          hasSeenFmoMigrationTour
        }
      });
    }).catch(error => logRavenException(error, 'Fetch has seen tour settings'));
  };
}
export function setHasSeenFmoAdminMigrationTour() {
  return dispatch => {
    return setHasSeenFmoAdminMigrationTourSetting(true).then(() => dispatch({
      type: SET_HAS_SEEN_FMO_MIGRATION_TOUR,
      payload: true
    })).catch(error => logRavenException(error, 'setHasSeenFmoAdminMigrationTour'));
  };
}
export function setHasSeenOnboardingTour() {
  return dispatch => {
    return setHasSeenDealStageTourSetting(true).then(() => dispatch({
      type: SET_HAS_SEEN_DEAL_STAGE_FORECAST_TOUR,
      payload: true
    }));
  };
}